import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewChecked,
} from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { marked } from 'marked';
import {
  FormArray,
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Roles, SweetAlertIcon } from '../../../shared/constants/enum';

//import { ChartService } from '../../../core/services/chart.service';
import { LoaderService } from '../../../core/services/loader.service';
import { SharedService } from '../../../shared/shared.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { forkJoin } from 'rxjs';
import { Validations } from '../../../shared/constants/validations';
import Swal from 'sweetalert2';
import { values } from 'lodash-es';
import { ChatService } from '../../../core/services/chat.service';

@Component({
  selector: 'app-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrl: './chat-message.component.scss'
})
export class ChatMessageComponent {
  @ViewChild('chatBody') chatBody!: ElementRef;
  rechargeForm!: UntypedFormGroup;
  sendClicked:boolean = false;
  tokenList: any[] = [];
  selectedToken: any;
  autosubmitted: boolean = false;
  chatHistory: Chat[] = [];
  messages: ChatMessage[] = [];
  selectedChatIndex = 0;
  newMessage = '';
  currentUserData: any;
  credits: number = 0;
  selectedTokens: any;
  selectedAmount: any;
  userWalletBalance: number = 0;
  rechargeModel!: BsModalRef;
  Roles = Roles;
  projectId: any;
  prifileValidations = Validations;
  aiFlatId: any;
  residentialUnits: any[] = [];
  messageErrorType: 'empty' | 'spaces' | '' = '';
  constructor(
    private formBuilder: UntypedFormBuilder,
    private modalService: BsModalService,
    private loaderService: LoaderService,
    private chatService: ChatService,
    private sharedService: SharedService,
    private sanitizer: DomSanitizer
  ) {
    const currentUserString = localStorage.getItem('currentUser');
    this.currentUserData = JSON.parse(currentUserString ?? '');
    this.residentialUnits = this.currentUserData?.residentialUnits;
    this.projectId = this.currentUserData?.project?.id;
    //console.log(this.residentialUnits)

    // const savedHistory = localStorage.getItem('chatHistory');
    this.rechargeForm = this.formBuilder.group({
      amount: [{ value: null, disabled: true }, [Validators.required]],
      tokens: [null, [Validators.required]],
    });
  }
  ngOnInit(): void {
    //  this.get_token_packages(); // hit only when role is consumer
    this.loadInitialData();
    // this.get_user_chat();
  }


  ngOnDestroy() {
    this.closeModel();
    console.log('Component destroyed!');
  }
  get rechargeFormControls() {
    return this.rechargeForm.controls;
  }
  get_token_packages() {
    this.loaderService.setLoading(true);
    this.chatService.get_token_packages().subscribe({
      next: (res) => {
        if (res.statusCode == 200) {
          this.tokenList = res.data;
          this.loaderService.setLoading(false);
        }
      },
    });
  }
  loadInitialData2() {
    this.loaderService.setLoading(true);

    forkJoin({
      creditsData: this.chatService.get_balance_credits(),
      chatHistoryData: this.chatService.get_user_chat_history(),
    }).subscribe({
      next: (res) => {
        console.log('Parallel Response:', res);

        // Balance credits
        this.credits = res.creditsData?.data?.userAiCredits || 0;
        this.userWalletBalance = res.creditsData?.data?.userWalletBalance || 0;
        this.aiFlatId = res.creditsData.aiFlatId || '';

        // Chat History
        const raw = res.chatHistoryData?.data || [];

        // map and assign the result
        this.chatHistory = raw.map((item: any) => ({
          ...item,
          tooltip: item?.question,
          question:
            (item?.question ?? '').toString().trim().length > 20
              ? item.question.trim().substring(0, 20) + '...'
              : (item?.question ?? '').toString().trim(),
        }));
        this.loaderService.setLoading(false);
      },
      error: (err) => {
        console.error(err);
        this.loaderService.setLoading(false);

        const errorMsg =
          err.error?.message || 'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR
        );
      },
    });
  };


  loadInitialData() {
    this.loaderService.setLoading(true);

    const apiCalls: any = {
      creditsData: this.chatService.get_balance_credits(),
      chatHistoryData: this.chatService.get_user_chat_history(),
      userCurrent_chat: this.chatService.get_user_chat()

    };

    // 👉 Add the 3rd API ONLY when user role is Consumer
    /*  if (this.currentUserData?.currentUserRoleDetails?.role === Roles.CONSUMER) {
       apiCalls.tokenPackages = this.chartService.get_token_packages();
     } */

    forkJoin(apiCalls).subscribe({
      next: (res: any) => {
        console.log("All API Responses:", res);
        console.log("All API Responses:", res.creditsData);
        console.log("All API Responses:", res.chatHistoryData);
        console.log("All API Responses:", res.userCurrent_chat);
        // ---- 1) Credits ----
        this.credits = res.creditsData?.data?.userAiCredits || 0;
        this.userWalletBalance = res.creditsData?.data?.userWalletBalance || 0;
        this.aiFlatId = res.creditsData?.data?.aiFlatId || '';

        // ---- 2) Chat History ----
        const rawHistory = res.chatHistoryData?.data || [];
        console.log("All API Responses:", rawHistory);
        this.chatHistory = rawHistory.map((item: any) => ({
          ...item,
          tooltip: item.question,
          question:
            (item?.question ?? '').trim().length > 20
              ? item.question.trim().substring(0, 20) + "..."
              : (item?.question ?? '').trim(),
        }));

        // ---- 3) Token Packages (only if Consumer role) ----
        if (res.tokenPackages) {
          this.tokenList = res.tokenPackages.data || [];
        }

        // user Chart
        this.loaderService.setLoading(false);
        // Load first chat into messages list
        this.loadChat(res.userCurrent_chat.data, 0);
        this.scrollToBottom();
        this.loaderService.setLoading(false);
      },
      error: (err) => {
        console.error(err);
        this.loaderService.setLoading(false);

        const errorMsg =
          err.error?.message || "Something went wrong. Please try again later.";

        this.sharedService.showMessageDialog(
          errorMsg,
          "",
          SweetAlertIcon.ERROR
        );
      },
    });
  }

  get_balance_credits() {
    this.chatService.get_balance_credits().subscribe({
      next: (res) => {
        this.credits = res?.data?.userAiCredits || 0;
        this.userWalletBalance = res.data?.userWalletBalance || 0;
        this.aiFlatId = res.data.aiFlatId || '';
      }, error: (err) => {
        console.error(err);
        this.loaderService.setLoading(false);

        const errorMsg =
          err.error?.message || "Something went wrong. Please try again later.";

        this.sharedService.showMessageDialog(
          errorMsg,
          "",
          SweetAlertIcon.ERROR
        );
      },
    })

  }
  get_user_chat() {
    this.loaderService.setLoading(true);
    this.chatService.get_user_chat().subscribe({
      next: (res) => {
        if (res.statusCode == 200) {
          console.log(res);
          if (res.data.length > 0) {
            let latestHistory = res.data.map((item: any) => ({
              ...item,
              title:
                item.question.length > 20
                  ? item.question.substring(0, 20) + '...'
                  : item.question,
            }));
            this.chatHistory = [...latestHistory]
            this.loaderService.setLoading(false);
            // Load first chat into messages list
            this.loadChat(res.data, 0);
            this.scrollToBottom();
          } else {
            this.loadChat(res.data, 0);
            this.loaderService.setLoading(false);

          }
        }
      },
      error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message || 'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR
        );
      },
    });
  }
  getChat_History() {
    //this.loaderService.setLoading(true);
    this.chatService.get_user_chat_history().subscribe({
      next: (res) => {
        if (res.statusCode == 200) {
          const rawHistory = res.chatHistoryData?.data || [];
          console.log("All API Responses:", rawHistory);
          this.chatHistory = rawHistory.map((item: any) => ({
            ...item,
            tooltip: item.question,
            question:
              (item?.question ?? '').trim().length > 20
                ? item.question.trim().substring(0, 20) + "..."
                : (item?.question ?? '').trim(),
          }));
        } else {
          this.loaderService.setLoading(false);
        }
      }, error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message || 'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR
        );
      },
    })
  }
  copytoHistory(event: any, index: number) {
    this.newMessage = event.tooltip;
    this.selectedChatIndex = index;
  }
  loadChat(chatData: any, index: number) {
    this.selectedChatIndex = index;

    this.messages = chatData
      .map((item: any) => {
        const userMsg: ChatMessage = {
          from: 'user',
          raw: item.question,
          text: this.sanitizer.bypassSecurityTrustHtml(
            marked.parse(item.question, { async: false }) as string
          ),
          time: new Date(item.questionTime).toLocaleTimeString(),
        };

        const botMsg: ChatMessage = {
          from: 'bot',
          raw: item.answer,
          text: this.sanitizer.bypassSecurityTrustHtml(
            marked.parse(item.answer, { async: false }) as string
          ),
          time: new Date(item.answerTime).toLocaleTimeString(),
        };
        this.loaderService.setLoading(false);
        return [userMsg, botMsg];
      })

      .flat();
  }

  sendQuestion() {
    this.sendClicked = true;
    const rawMessage = this.newMessage ?? '';
    if (rawMessage.length === 0) {
      this.messageErrorType = 'empty';
      return;
    }
    if (rawMessage.trim().length === 0) {
      this.messageErrorType = 'spaces';
      return;
    }
    this.messageErrorType = '';
    this.sendClicked = false;
    this.loaderService.setLoading(true);
    let request = {
      question: rawMessage.trim(),
    };

    this.chatService.ask_question(request).subscribe({
      next: (res) => {
        if (res.statusCode == 200) {
          // this.get_user_chat();
          this.loadInitialData(); //Balance Credits,chtHistory api
          this.newMessage = '';
          console.log(res);
        }
      },


    });
  }

  onMessageInput() {
    if ((this.newMessage || '').trim().length > 0) {
      this.sendClicked = false;
    }
    if (this.messageErrorType) {
      this.messageErrorType = '';
    }
  }

  copyMessage(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied:', text);
    });
  }

  /*  saveHistory() {
    localStorage.setItem('chatHistory', JSON.stringify(this.chatHistory));
  }
 */
  scrollToBottom() {
    setTimeout(() => {
      if (this.chatBody) {
        const container = this.chatBody.nativeElement;
        container.scrollTop = container.scrollHeight;
      }
    }, 0);
  }

  clearChat() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: ` Do you want to delete this chat?`,
        icon: 'warning',
        confirmButtonText: 'Yes, Proceed',
        cancelButtonText: 'No, Cancel',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.chatService.clear_chat().subscribe({
            next: (res) => {
              if (res.statusCode == 200) {
                this.get_user_chat();
                this.sharedService.showMessageDialog(
                  res.message,
                  '',
                  SweetAlertIcon.SUCCESS
                );
              }
            },
            error: (err) => {
              console.log(err);
              this.loaderService.setLoading(false);

              // Check if backend returned an error.message
              const errorMsg =
                err.error?.message || 'Something went wrong. Please try again later.';

              this.sharedService.showMessageDialog(
                errorMsg,
                '',
                SweetAlertIcon.ERROR
              );
            },
          });
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
        }
      });



  }
  clearHistory() {

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: ` Do you want to delete this Chat History?`,
        icon: 'warning',
        confirmButtonText: 'Yes, Proceed',
        cancelButtonText: 'No, Cancel',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.chatService.delete_chat_history().subscribe({
            next: (res) => {
              if (res.statusCode == 200) {
                this.chatHistory = [];
                this.getChat_History()
                this.sharedService.showMessageDialog(
                  res.message,
                  '',
                  SweetAlertIcon.SUCCESS
                );
              }
            },
          });
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
        }
      });

  }
  recharge(addInvoiceModal: any) {
    this.rechargeForm.get('amount')?.setValue(null);
    this.rechargeForm.get('tokens')?.setValue(null);
    this.rechargeModel = this.modalService.show(addInvoiceModal, {
      class: 'modal-dialog-centered',
      backdrop: 'static',
    });
    this.get_token_packages();
    this.get_balance_credits();

  }
  onTokenChange(event: any) {
    if (!event) {
      this.selectedToken = {};
      this.rechargeForm.get('amount')?.setValue('');
      return;
    }
    this.selectedToken = event;
    // event itself is the selected token object
    this.rechargeForm.get('amount')?.setValue(event.id);
    console.log('Auto select amount:', this.rechargeForm.get('amount')?.value);
  }
  closeModel() {
    this.rechargeModel?.hide();
  }
  purchaseToken() {
    let faltId = this.residentialUnits.length > 0 ? this.residentialUnits[0]?.residentialUnitId : this.aiFlatId

    if (faltId) {
      console.log('triger ');
      this.loaderService.setLoading(true);
      this.autosubmitted = true;
      if (this.rechargeForm.invalid) {
        this.loaderService.setLoading(false);
        return;
      } else {
        let request = {
          packageId: this.selectedToken?.id,
          projectId: this.projectId,
          residentialUnitId: this.residentialUnits[0]?.residentialUnitId,
        };
        this.chatService.purchase_tokens(request).subscribe({
          next: (res) => {
            if (res.statusCode == 200) {
              this.get_balance_credits()
              this.closeModel();
              this.loaderService.setLoading(false);
              this.sharedService.showMessageDialog(
                res.message,
                '',
                SweetAlertIcon.SUCCESS
              );
              console.log(res);
            }
          },
          error: (err) => {
            console.log(err);
            this.loaderService.setLoading(false);

            // Check if backend returned an error.message
            const errorMsg =
              err.error?.message ||
              'Something went wrong. Please try again later.';

            this.sharedService.showMessageDialog(
              errorMsg,
              '',
              SweetAlertIcon.ERROR
            );
          },
        });
      }
    }
  }
  formatTimeOnly(time: string): string {
    if (!time) return '';

    const [h, m, s] = time.split(':').map(Number);
    const date = new Date();
    date.setHours(h, m, s || 0);

    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  }

}
export interface ChatMessage {
  from: 'user' | 'bot';
  text: SafeHtml; // HTML for UI
  raw: string; // plain string for copying
  time: string;
  isCopied?: boolean;
}

interface Chat {
  question: string;
  tooltip: string;
  messages: ChatMessage[];
}

